;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { ValidParamsOptions } from 'src/deprecated/types/api'

/**
 * @param options A request options object.
 * @returns A URLSearchParams instance.
 */
export function getPreparedParams<T extends ValidParamsOptions>(options: T) {
  const params = new URLSearchParams()

  for (const key in options) {
    const value = options[key]

    // Ensure value is available before continuing.
    if (value === undefined || value === null) continue

    if (typeof value === 'string') params.set(key, value)
    if (typeof value === 'number') params.set(key, value.toString())
    if (typeof value === 'boolean') params.set(key, value ? 'true' : 'false')

    if (Array.isArray(value)) {
      for (const item of value) {
        params.append(key, String(item).toString())
      }
    }
  }

  return params
}
